export const STORE_NAME = 'publishpress-future/workflow-editor';
